// src/json/overlayData.json
export const overlaySectiongeneralContracting = {
    imageUrl: "/assets/imgs/services/7generalContracting/overlaySection/fondo.jpg",
    text: "The best Building Envelope Renewal /",
    highlight: "High-Rise Painting & Restoration services."
};
